<template>
  <div
    class="grid-container full"
    :style="styleAttributes"
  >
    <div class="grid-x grid-margin-x align-center">
      <div class="cell small-12 medium-8 large-8">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getStyleAttributes } from '../../helpers/getAttributes';

const props = defineProps({
  attributes: {
    type: Object,
    default: () => {},
  },
});

const styleAttributes = ref({});
onMounted(() => {
  if (props.attributes) {
    styleAttributes.value = getStyleAttributes(props.attributes);
  }
});
</script>
